export enum PAGE_STATE {
  BREADCRUMBS = 'breadcrumbs',
  HEADER = 'header',
  ACTIONS = 'actions',
  KPIS = 'kips',
  ALL = 'all'
}
